import { TPaymentMethodsState } from "./paymentMethods.types";

export const initialState: TPaymentMethodsState = {
  data: [],
  isLoading: false,
  error: null,
};
